import { render, staticRenderFns } from "./Specific.vue?vue&type=template&id=2c6d8d94&"
import script from "./Specific.vue?vue&type=script&lang=js&"
export * from "./Specific.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports